import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";

 import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";
import { featurePaths } from "@feature/constants/paths.constant";

const JobsListPage = lazy(() => import("@feature/pages/JobList"));
const CreateJobPage = lazy(() => import("@feature/pages/CreateJob"));
const UpdateJobPage = lazy(() => import("@feature/pages/id/EditWorkOrderForm"));
const AddMultipleServiceFormPage = lazy(() => import("@feature/pages/AddMultiService"));
const UpdatePreAlertPage = lazy(() => import("@feature/pages/UpdatePreAlertData"));
const ReturnSenderInstructionPage = lazy(() => import("@feature/pages/ReturnSenderInstruction"));
const RSIPreviewPage = lazy(() => import("@feature/pages/RSIPreview"));
const ViewPreAlertPage = lazy(() => import("@feature/pages/ViewPreAlertData"));
@injectable()
@registry([{ token: FeatureToken, useClass: JobList }])
class JobList implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Job List",
                path: featurePaths.JobList,
                page: JobsListPage
            },
            {
                title: "Create JOb",
                path: featurePaths.CreateJob,
                page: CreateJobPage
            },
            {
                title: "Edit JOb",
                path: featurePaths.EditJob,
                page: UpdateJobPage
            }
            ,
            {
                title: "Add Multiple ServiceForm",
                path: featurePaths.AddmultipleService,
                page: AddMultipleServiceFormPage
            } ,
            {
                title: "Pre Alert Data",
                path: featurePaths.UpdatePreAlert,
                page: UpdatePreAlertPage
            }
            ,
            {
                title: "Return Sender InstructionPage",
                path: featurePaths.ReturnSenderInstruction,
                page: ReturnSenderInstructionPage
            }
            ,
            {
                title: "RSI Preview Page",
                path: featurePaths.RSIPreview,
                page: RSIPreviewPage
            },
            {
                title: "View Pre-Alert Data",
                path: featurePaths.ViewPreAlert,
                page: ViewPreAlertPage
            }
        ]
    };
}
